export enum ReviewSubStep {
    Selection = "Selection",
    Analysis = "Analysis",
  }